import { render } from "./CarouselContainer.vue?vue&type=template&id=461bdc4f"
import script from "./CarouselContainer.vue?vue&type=script&lang=js"
export * from "./CarouselContainer.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__